import { render } from "./InstallerJoinType.vue?vue&type=template&id=3b147a77&scoped=true&ts=true"
import script from "./InstallerJoinType.vue?vue&type=script&lang=ts"
export * from "./InstallerJoinType.vue?vue&type=script&lang=ts"

import "./InstallerJoinType.vue?vue&type=style&index=0&id=3b147a77&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b147a77"]])

export default __exports__